import { Injectable } from '@angular/core';
import { ApiService, PagedSearch } from '../../../shared/index';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { Office } from './office.model';
import { OfficeSearch } from './office-search.model';
import { Official } from './official.model';
import { OfficialSearch } from './official-search.model';
import { VoterVoiceSettingsDto } from './voter-voice-settings.dto';
import { VoterVoiceProfileReadDto } from './voter-voice-profile-read.dto';
import { GovernmentDto } from './government.dto';
import { VoterVoiceSyncConfigDto } from './voter-voice-sync-config.dto';

@Injectable()
export class VoterVoiceService {
  /**
   * inject
   */
  public constructor(private _api: ApiService) {}

  public getProfileVoterVoiceOfficials(profileId: number): Promise<Array<VoterVoiceProfileReadDto>> {
    return this._api.get(`VoterVoice/Profile/${profileId}/officials`);
  }

  public getVoterVoiceGovernments(): Promise<Array<GovernmentDto>> {
    return this._api.get(`VoterVoice/Governments`);
  }

  public hasVoterVoiceSettings(): Promise<boolean> {
    return this._api.get('VoterVoice/Settings').then((data: any) => {
      return data && !!data.AssociationId && !!data.ApiKey;
    });
  }

  public getVoterVoiceSettings(): Promise<VoterVoiceSettingsDto> {
    return this._api.get('VoterVoice/Settings');
  }

  updateVoterVoiceSettings(voterVoiceSettings: VoterVoiceSettingsDto): Promise<void> {
    return this._api.post('VoterVoice/Settings', voterVoiceSettings);
  }

  /**
   * search for voter voice offices
   * @param search
   */
  public searchOffices(search: OfficeSearch): Promise<PagedResult<Array<Office>>> {
    return this._api.getPaged('VoterVoice/Offices', search);
  }

  /**
   * search for voter voice officials
   * @param search
   */
  public searchOfficials(search: OfficialSearch): Promise<PagedResult<Array<Official>>> {
    return this._api.getPaged('VoterVoice/Officials', search);
  }

  public syncVoterVoice(settings: VoterVoiceSyncConfigDto): Promise<void> {
    return this._api.post('VoterVoice/Sync', settings);
  }

  public getLastUpdateDate(): Promise<Date> {
    return this._api.get('VoterVoice/LastProfileUpdatedDate');
  }
}
